module.exports = __webpack_public_path__ + "img/checked2.e138c8d5.png";